/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductStagingDTOFromJSON, ProductStagingDTOToJSON, } from './ProductStagingDTO';
/**
 * Check if a given object implements the ProductStagingCatalogDTO interface.
 */
export function instanceOfProductStagingCatalogDTO(value) {
    return true;
}
export function ProductStagingCatalogDTOFromJSON(json) {
    return ProductStagingCatalogDTOFromJSONTyped(json, false);
}
export function ProductStagingCatalogDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
        'id': json['id'] == null ? undefined : json['id'],
        'productStaging': json['productStaging'] == null ? undefined : ProductStagingDTOFromJSON(json['productStaging']),
        'itemHeight': json['itemHeight'] == null ? undefined : json['itemHeight'],
        'itemLength': json['itemLength'] == null ? undefined : json['itemLength'],
        'itemWidth': json['itemWidth'] == null ? undefined : json['itemWidth'],
        'itemWeight': json['itemWeight'] == null ? undefined : json['itemWeight'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'title': json['title'] == null ? undefined : json['title'],
        'categoryBsr': json['categoryBsr'] == null ? undefined : json['categoryBsr'],
        'subcategoryBsr': json['subcategoryBsr'] == null ? undefined : json['subcategoryBsr'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'productType': json['productType'] == null ? undefined : json['productType'],
        'variationCount': json['variationCount'] == null ? undefined : json['variationCount'],
        'reviewRating': json['reviewRating'] == null ? undefined : json['reviewRating'],
        'reviewCount': json['reviewCount'] == null ? undefined : json['reviewCount'],
        'catalogInfoLastModifiedDate': json['catalogInfoLastModifiedDate'] == null ? undefined : (new Date(json['catalogInfoLastModifiedDate'])),
    };
}
export function ProductStagingCatalogDTOToJSON(json) {
    return ProductStagingCatalogDTOToJSONTyped(json, false);
}
export function ProductStagingCatalogDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
        'id': value['id'],
        'productStaging': ProductStagingDTOToJSON(value['productStaging']),
        'itemHeight': value['itemHeight'],
        'itemLength': value['itemLength'],
        'itemWidth': value['itemWidth'],
        'itemWeight': value['itemWeight'],
        'imageUrl': value['imageUrl'],
        'title': value['title'],
        'categoryBsr': value['categoryBsr'],
        'subcategoryBsr': value['subcategoryBsr'],
        'brand': value['brand'],
        'productType': value['productType'],
        'variationCount': value['variationCount'],
        'reviewRating': value['reviewRating'],
        'reviewCount': value['reviewCount'],
        'catalogInfoLastModifiedDate': value['catalogInfoLastModifiedDate'] == null ? undefined : ((value['catalogInfoLastModifiedDate']).toISOString()),
    };
}
